import React from "react";
import { useTranslation } from "react-i18next";
import {
    Dialog,
    DialogTitle,
    IconButton,
    TextField,
    InputAdornment,
    Box,
    Typography,
    Chip,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

const SelectedLocationsDialog = ({ open, onClose, locations = [], setValue }) => {
    const { t } = useTranslation("dashboard");
    const [search, setSearch] = React.useState("");

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleRemove = (locationToRemove) => {
        setValue("location", locations.filter((loc) => loc._id !== locationToRemove._id));
    };

    const filteredLocations = locations.filter((loc) =>
        loc.businessLocationName.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="xs"
            transitionDuration={500}
            PaperProps={{
                sx: {
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10,
                    borderBottomLeftRadius: !fullScreen && 10,
                    borderBottomRightRadius: !fullScreen && 10,
                    p: 2,
                    width: "100%",
                    mx: "auto",
                    mt: fullScreen ? "auto" : undefined,
                    maxHeight: "80vh", // Ensures it doesn't overflow
                    overflow: "hidden", // Keeps scroll within dialog
                    display: "flex",
                    flexDirection: "column"
                },
            }}
        >
            <DialogTitle sx={{ textAlign: "center", fontWeight: 600, position: "relative", pb: 1 }}>
                {t("teamMemberLinkingDialogAllLocations")}
                <IconButton
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Box px={2} pb={2}>
                <TextField
                    fullWidth
                    placeholder={t("teamMemberLinkingDialogSearch")}
                    size="small"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    sx={{
                        mb: 2,
                        "& .MuiOutlinedInput-root": {
                            borderRadius: 3,
                            backgroundColor: "#f3f3f3",
                        },
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon sx={{ color: "#999" }} />
                            </InputAdornment>
                        ),
                    }}
                />

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxHeight: "60vh", overflowY: "auto" }}>
                    {filteredLocations.length > 0 ? (
                        filteredLocations.map((loc) => (
                            <Chip
                                key={loc._id}
                                label={loc.businessLocationName}
                                onDelete={() => handleRemove(loc)}
                                sx={{
                                    bgcolor: "#E5CCFF",
                                    color: "#3A0099",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    px: 1.5,
                                    borderRadius: "8px",
                                    justifyContent: "space-between",
                                    width: "fit-content",
                                    "& .MuiChip-deleteIcon": {
                                        color: "#8800F7",
                                    },
                                }}
                            />
                        ))
                    ) : (
                        <Typography sx={{ color: "#888", textAlign: "center", mt: 4 }}>
                            {t("teamMemberLinkingDialogNoMatchingLocation")}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Dialog>
    );
};

export default SelectedLocationsDialog;
